import { Component, effect, input, signal } from '@angular/core';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

@Component({
  selector: 'app-pdf-viewer',
  imports: [PdfJsViewerModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.sass'],
})
export class PdfViewerComponent {
  pdfUrl = input.required<string>();
  viewerId = input<string>();

  escapedUrl = signal<string>('');

  constructor() {
    effect(() => {
      const newUrl = this.pdfUrl();

      this.escapedUrl.set('');

      setTimeout(() => {
        try {
          const url = new URL(newUrl);
          this.escapedUrl.set(
            encodeURIComponent(url.pathname + url.search + url.hash),
          );
        } catch {
          this.escapedUrl.set('');
        }
      }, 200);
    });
  }
}
